import React, { useState, useEffect } from "react";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";

import SparkasseIcon from "assets/images/svg/sparkasse-icon.svg";
import InfoIconGreyDark from "assets/images/svg/info-icon-grey-dark.svg";
import UpperBlock from "./UpperBlock";
import SelectInput from "components/SelectInput";
import NewLoader from "components/NewLoader";
import { fetchUser } from "api";
import { ACCOUNT_HASH_VARIABLES } from "constants/index";

const messages = {
    selectYourBank: "select_your_bank",
    toLoginPleaseSelectBank: "to_login_please_select_bank",
    selectBank: "select_bank",
    bySelectingBank: "by_selecting_bank",
    consent: "consent",
    redirectedToSparkasse: "redirected_to_sparkasse",
    continueToVerification: "continue_to_verification",
    redirectingToSparkasse: "redirecting_to_sparkasse",
};

const BRANCH_OPTIONS = [{ label: "Sparkasse Bremen", value: "29050101" }];

const Branch = ({ backSlideEffect, setBackSlideEffect, open, setStep }) => {
    useSideModalScrollToTop();
    const { formatMessage } = useFormattedMessage();

    const [isLoading, setLoading] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState({
        label: formatMessage(messages.selectBank),
        value: "",
    });
    const [user, setUser] = useState({});

    const handleConsentClick = () => {
        setBackSlideEffect("step-slide-left");
        setStep("consentDetails");
    };

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const userData = await fetchUser();
                if (userData) setUser(userData);
            } catch (err) {
                console.error("Error fetching user:", err);
            }
        };

        fetchUserDetails();
    }, []);

    const handleContinueClick = () => {
        setLoading(true);
        const fromIdentification =
            window.location.hash.substring(1) === ACCOUNT_HASH_VARIABLES.ACCOUNT_LINK_SPARKASSE_IDENTIFICATION;
        const oauthUrl = `/auth/sparkasse/oauth?uid=${user.uid}&email=${encodeURIComponent(user.email)}&blz=${selectedBranch.value}&fromIdentification=${fromIdentification}`;
        window.location = oauthUrl;
    };

    return (
        <div className={`link-sparkasse-branch-screen ${backSlideEffect}`}>
            <UpperBlock
                icon={<SparkasseIcon />}
                title={formatMessage(messages.selectYourBank)}
                content={formatMessage(messages.toLoginPleaseSelectBank)}
            />

            <div className="p-6">
                <h5 className="mt-0 fw-400">{formatMessage(messages.selectBank)}</h5>

                <SelectInput
                    className="mb-4"
                    classNamePrefix="select"
                    name="branch"
                    options={BRANCH_OPTIONS}
                    value={selectedBranch}
                    onChange={(value) => {
                        setSelectedBranch(value);
                        setLoading(false);
                    }}
                />

                <span className="text-14 d-block">
                    {formatMessage(messages.bySelectingBank)}{" "}
                    <span className="primary-color fw-600 cursor-pointer" onClick={handleConsentClick}>
                        {formatMessage(messages.consent)}
                    </span>
                    .
                </span>
            </div>

            {open && (
                <div className="bottom-bar-container px-6 d-block">
                    <div className="d-flex mb-4">
                        <div>
                            <InfoIconGreyDark />
                        </div>
                        <span className="text-14 ml-3 d-block">{formatMessage(messages.redirectedToSparkasse)}</span>
                    </div>

                    <button className="mw-100" disabled={!selectedBranch.value || isLoading} onClick={handleContinueClick}>
                        {isLoading ? (
                            <>
                                <NewLoader /> {formatMessage(messages.redirectingToSparkasse)}
                            </>
                        ) : (
                            formatMessage(messages.continueToVerification)
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Branch;
